module.exports = __webpack_public_path__ + "img/Sexy Gaming.2e592afa.jpg";